import React from "react";
import Input from "../Input";
import PhoneInputComponent from "../PhoneInput/index";
// import {parsePhoneNumber} from "react-phone-number-input";
const Step1 = ({
  form,
  setForm,
  onPhoneNumberChange,
  onFormChange,
  errors,
  next,
  prev,
  countries,
  user,
  roles,
  title,
  agencies,
}) => {
  return (
    <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8">
      <div className="text-center mb-8">
        <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
          </svg>
        </div>
        <h2 className="text-2xl font-bold text-gray-900 mb-2">
          {title ? title : "Personal Information"}
        </h2>
        <p className="text-gray-600">
          Please provide the agent's personal details to create their profile.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-700">
            First Name <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            name="firstname"
            value={form.firstname}
            onChange={onFormChange}
            placeholder="Enter first name"
            className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors duration-200 ${
              errors?.firstname ? 'border-red-300 bg-red-50' : 'border-gray-300'
            }`}
          />
          {errors?.firstname && (
            <p className="text-red-500 text-sm flex items-center">
              <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
              </svg>
              {errors?.firstname}
            </p>
          )}
        </div>

        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-700">
            Other Names
          </label>
          <input
            type="text"
            name="othernames"
            value={form.othernames}
            onChange={onFormChange}
            placeholder="Enter other names"
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors duration-200"
          />
          {errors?.othernames && (
            <p className="text-red-500 text-sm flex items-center">
              <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
              </svg>
              {errors?.othernames}
            </p>
          )}
        </div>

        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-700">
            Last Name <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            name="lastname"
            value={form.lastname}
            onChange={onFormChange}
            placeholder="Enter last name"
            className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors duration-200 ${
              errors?.lastname ? 'border-red-300 bg-red-50' : 'border-gray-300'
            }`}
          />
          {errors?.lastname && (
            <p className="text-red-500 text-sm flex items-center">
              <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
              </svg>
              {errors?.lastname}
            </p>
          )}
        </div>

        {agencies && (
          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700">
              Agency <span className="text-red-500">*</span>
            </label>
            <div className="relative">
              <select
                disabled={!user?.isAdmin}
                value={form?.agency_id}
                onChange={onFormChange}
                name="agency_id"
                className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors duration-200 appearance-none bg-white ${
                  errors.agency_id ? 'border-red-300 bg-red-50' : 'border-gray-300'
                } ${!user?.isAdmin ? 'bg-gray-50 cursor-not-allowed' : ''}`}
              >
                <option value="" disabled>
                  Select an Agency
                </option>
                {agencies.map((agency) => (
                  <option key={agency.id} value={agency.id}>{agency.name}</option>
                ))}
              </select>
              <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-3">
                <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </div>
            </div>
            {errors.agency_id && (
              <p className="text-red-500 text-sm flex items-center">
                <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                </svg>
                {errors.agency_id}
              </p>
            )}
          </div>
        )}

        <div className="flex flex-col">
          <Input
            containerStyle={"w-full md:w-auto"}
            labelFor={"Address"}
            placeholder=""
            labelName={"Address"}
            type="text"
            value={form.address}
            onChange={onFormChange}
            name="address"
          />

          {errors?.address && (
            <p className="text-red-500 text-[10px] italic pt-1">
              {errors?.address}
            </p>
          )}
        </div>

        <div className="flex flex-col">
          <Input
            containerStyle={"w-full md:w-auto"}
            labelFor={"Email"}
            placeholder="kojo@gmail.com"
            labelName={"Email"}
            type="email"
            value={form.email}
            onChange={onFormChange}
            name="email"
          />

          {errors?.email && (
            <p className="text-red-500 text-[10px] italic pt-1">
              {errors?.email}
            </p>
          )}
        </div>

        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-700">
            Phone Number <span className="text-red-500">*</span>
          </label>
          <PhoneInputComponent
            labelFor={"msisdn"}
            placeholder="Enter phone number"
            value={form.msisdn}
            onChange={onPhoneNumberChange}
            name="msisdn"
            defaultCountry={form.phone_number_prefix}
            withCountryCallingCode
            international={true}
            className={`flex text-sm bg-white PhoneInput-2 ${
              errors?.msisdn ? 'border-red-300 bg-red-50' : ''
            }`}
            containerStyles={"w-full"}
          />
          {errors?.msisdn && (
            <p className="text-red-500 text-sm flex items-center">
              <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
              </svg>
              {errors?.msisdn}
            </p>
          )}
        </div>

        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-700">
            Country <span className="text-red-500">*</span>
          </label>
          <div className="relative">
            <select
              disabled={!user?.isAdmin}
              value={form.country_id}
              onChange={onFormChange}
              name="country_id"
              className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors duration-200 appearance-none bg-white ${
                errors.country_id ? 'border-red-300 bg-red-50' : 'border-gray-300'
              } ${!user?.isAdmin ? 'bg-gray-50 cursor-not-allowed' : ''}`}
            >
              <option value="" disabled>
                Select a country
              </option>
              {countries.map((country) => (
                <option key={country.id} value={country.id}>
                  {country.name}
                </option>
              ))}
            </select>
            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-3">
              <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </div>
          </div>
          {errors.country_id && (
            <p className="text-red-500 text-sm flex items-center">
              <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
              </svg>
              {errors.country_id}
            </p>
          )}
        </div>

        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-700">
            Role <span className="text-red-500">*</span>
          </label>
          <div className="relative">
            <select
              value={form.agent_role}
              onChange={onFormChange}
              name="agent_role"
              className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors duration-200 appearance-none bg-white ${
                errors.agent_role ? 'border-red-300 bg-red-50' : 'border-gray-300'
              }`}
            >
              <option value="" disabled>
                Select a role
              </option>
              {roles.map((role) => (
                <option key={role.name} value={role.name}>
                  {role.name}
                </option>
              ))}
            </select>
            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-3">
              <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </div>
          </div>
          {errors.agent_role && (
            <p className="text-red-500 text-sm flex items-center">
              <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
              </svg>
              {errors.agent_role}
            </p>
          )}
        </div>
      </div>

      <div className="flex justify-end pt-8 border-t border-gray-100 mt-8">
        <button
          onClick={next}
          className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-medium px-6 py-3 rounded-lg transition-colors duration-200 shadow-sm hover:shadow-md"
        >
          <span>Continue</span>
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default Step1;
